import { render, staticRenderFns } from "./ReporteScrapMotivo.vue?vue&type=template&id=2fd4872a&scoped=true"
import script from "./ReporteScrapMotivo.vue?vue&type=script&lang=js"
export * from "./ReporteScrapMotivo.vue?vue&type=script&lang=js"
import style0 from "./ReporteScrapMotivo.vue?vue&type=style&index=0&id=2fd4872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4872a",
  null
  
)

export default component.exports